<template>
  <div class="auth-process-container">
    <div class="auth-process">
      <q-card bordered flat class="auth-process-card">
        <img :src="require('../assets/brands/logo.png')" alt="" />
        <div
          style="display:flex;align-items:center;justify-content:center;text-align:center;margin:10px;font-size:14px;color:#666;font-weight:bold"
          v-text="message"
        />
        <div class="other-things" v-if="message === null && error === null">
          Please wait...
        </div>
        <div class="other-things" style="color:#ff3300" v-if="error !== null" v-text="error" />
      </q-card>
    </div>
  </div>
</template>

<script>
import Layout from '../components/Layout'
import axios from '../axios/'
export default {
  components: {
    Layout
  },
  data() {
    return {
      message: null,
      error: null
    }
  },
  async created() {
    try {
      const {
        data: {
          data: { url }
        }
      } = await axios.post('/zubie/login')
      this.message = 'You are being redirected...'
      setTimeout(() => {
        document.location.href = url
      }, 2000)
    } catch (error) {
      this.error = 'Something went wrong!'
    }
  }
}
</script>
